import { render } from "./BlackFridayHome.vue?vue&type=template&id=1f376207&scoped=true"
import script from "./BlackFridayHome.vue?vue&type=script&lang=js"
export * from "./BlackFridayHome.vue?vue&type=script&lang=js"

import "./BlackFridayHome.vue?vue&type=style&index=0&id=1f376207&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f376207"],['__file',"src/views/pre/BlackFridayHome.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f376207"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f376207', __exports__)) {
    console.log('reload')
    api.reload('1f376207', __exports__)
  }
  
  module.hot.accept("./BlackFridayHome.vue?vue&type=template&id=1f376207&scoped=true", () => {
    console.log('re-render')
    api.rerender('1f376207', render)
  })

}


export default __exports__